import { MapPin, Globe2, Building2 } from "lucide-react";

/**
 * Student residency types. Order here drives display order in filters,
 * report summary cards, and dropdowns.
 */
export const STUDENT_TYPES = ["Local", "Regional", "International"];

/**
 * Visual language for each type. Local = success, Regional = warning,
 * International = brand.
 */
export const STUDENT_TYPE_STYLES = {
    Local: {
        chip: "bg-success-soft text-success",
        solid: "bg-success text-white",
        bg: "bg-success-soft",
        fg: "text-success",
        icon: MapPin,
    },
    Regional: {
        chip: "bg-warning-soft text-warning",
        solid: "bg-warning text-white",
        bg: "bg-warning-soft",
        fg: "text-warning",
        icon: Building2,
    },
    International: {
        chip: "bg-brand-soft text-brand",
        solid: "bg-[#4A6F8F] text-white",
        bg: "bg-brand-soft",
        fg: "text-brand",
        icon: Globe2,
    },
};

export function getStudentTypeStyle(type) {
    return STUDENT_TYPE_STYLES[type] || STUDENT_TYPE_STYLES.Local;
}
